import React, { useEffect, useState } from 'react';
import { ModalFooter, Row } from 'reactstrap';
import { ButtonWithLoadingIcon } from '../../components/common/ButtonWithLoadingIcon';
import { Colxx } from '../../components/common/CustomBootstrap';
import { ProductDetailHeader } from '../../components/listings/ProductDetailHeader';
import { Status } from '../../constants/status';
import productAPI from '../../services/API/product';
import { BasicProductProfile } from './BasicProductProfile';
import { LoadingContainer } from '../../components/common/LoadingContainer';

export const RentalModalContent = ({ productData = {}, onClose }) => {
  const [cancellingListing, setCancellingListing] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(productData);
  const [loading, setLoading] = useState(false);

  const handleProductCancelListing = async () => {
    const data = {
      product_id: productData.id,
    };
    setCancellingListing(true);
    try {
      const rentalResult = await productAPI.cancelRental(data);
      console.log('rental resutl', rentalResult);
      onClose(true);
    } catch (error) {}
    setCancellingListing(false);
  };

  useEffect(() => {
    const getProduct = async () => {
      try {
        setLoading(true);
        const productDataRes = await productAPI.getProductById(
          selectedProduct.id
        );
        setSelectedProduct(productDataRes);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    };
    getProduct();
  }, []);

  return (
    <>
      {loading ? (
        <LoadingContainer />
      ) : (
        <>
          <ProductDetailHeader
            title={selectedProduct.title || selectedProduct.product_title}
          />

          <Row className='mt-4 '>
            <Colxx xxs='12'>
              <BasicProductProfile productData={selectedProduct} />
            </Colxx>

            {/* <Colxx xxs='12'>
          {productData.status === Status.rented &&
            !productData.consignment_cancelled && (
              <ModalFooter>
                <ButtonWithLoadingIcon
                  disabled={cancellingListing}
                  loading={cancellingListing}
                  color='primary'
                  size='lg'
                  onClick={handleProductCancelListing}
                >
                  Cancel Listing
                </ButtonWithLoadingIcon>
              </ModalFooter>
            )}
        </Colxx> */}
          </Row>
        </>
      )}
    </>
  );
};
